import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../configuration';
import { AdCreative } from '../../api/ads/ads.api';
import NativeAdCard from './native-ad-card';

export interface CreatorAdCardProps {
  placement: 'Reels' | 'Video' | 'Profile';
  creatorId?: string;
  postId?: string;
  /** Chủ bài (nếu biết) để không hiện quảng cáo cho chính creator. */
  ownerId?: string;
  variant?: 'card' | 'reel';
  initialAd?: AdCreative;
}

const same = (a?: string, b?: string) => !!a && !!b && a.toLowerCase() === b.toLowerCase();

/**
 * Thẻ quảng cáo trên nội dung creator. Máy chủ quyết định có quảng cáo hay không
 * (mảng rỗng thì không hiện gì). Không hiện cho khách chưa đăng nhập hay chính chủ nội dung.
 */
const CreatorAdCard: React.FC<CreatorAdCardProps> = ({
  placement,
  creatorId,
  postId,
  ownerId,
  variant = 'card',
  initialAd,
}) => {
  const viewerId = useSelector((s: RootState) => s.features.auth.profile?.userId);
  if (!viewerId) return null;
  if (same(viewerId, creatorId) || same(viewerId, ownerId)) return null;
  return (
    <NativeAdCard
      placement={placement}
      creatorId={creatorId}
      postId={postId}
      variant={variant}
      initialAd={initialAd}
    />
  );
};

export default CreatorAdCard;
